/** Shown until .env.local has real Firebase values, instead of a sign-in button that can't work. */
export default function Setup() {
  const steps = [
    ['Create a Firebase project', 'console.firebase.google.com → Add project. The free Spark plan is enough.'],
    ['Turn on Google sign-in', 'Build → Authentication → Sign-in method → Google → Enable.'],
    ['Create a Firestore database', 'Build → Firestore Database → Create. Pick a region near you; asia-south1 for India.'],
    ['Register a web app', 'Project settings → General → Your apps → Web. Copy the config values.'],
    ['Fill in .env.local', 'Copy .env.example to .env.local, paste the values, and restart npm run dev.']
  ];
  return (
    <div className="view no-fab" style={{ paddingTop: 28 }}>
      <div className="wordmark" style={{ fontSize: 30 }}>evenhouse<em>.</em></div>
      <p className="muted" style={{ fontSize: 14, lineHeight: 1.6, marginTop: 10 }}>
        Almost there. The app needs a Firebase project before it can sign anyone in.
      </p>
      <div className="list" style={{ marginTop: 18 }}>
        {steps.map(([t, s], i) => (
          <div className="row" key={t}>
            <span className="glyph tint" style={{ fontWeight: 700 }}>{i + 1}</span>
            <span className="main">
              <span className="t">{t}</span>
              <span className="s" style={{ whiteSpace: 'normal' }}>{s}</span>
            </span>
          </div>
        ))}
      </div>
      <p className="muted" style={{ fontSize: 12.5, lineHeight: 1.55, marginTop: 16 }}>
        Then deploy the security rules with <b>firebase deploy --only firestore:rules</b>.
        Full steps are in README.md.
      </p>
    </div>
  );
}
